<template>
  <div class="app-loading">
    <div class="loading-backdrop"></div>

    <div class="loading-wrapper">
      <!-- Animated Shield Container -->
      <div class="shield-container">
        <!-- Outer rotating rings -->
        <div class="ring-outer"></div>
        <div class="ring-middle"></div>
        <div class="ring-inner"></div>
        
        <!-- Shield icon with pulse effect -->
        <div class="shield-icon-wrapper">
          <div class="shield-glow"></div>
          <v-icon
            size="42"
            class="shield-icon"
          >
            mdi-shield-account
          </v-icon>
        </div>
      </div>

      <!-- Title with gradient -->
      <div class="loading-title">
        <span class="title-main">سامانه ابریشم</span>
      </div>

      <!-- Loading text with wave effect -->
      <div class="loading-text">
        <span class="waiting-text">لطفاً منتظر بمانید</span>
        <div class="loading-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppLoading",
};
</script>

<style scoped>
/* ====================== OVERLAY ====================== */
.app-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-loading--inline {
  position: absolute;
  z-index: 10;
}

.loading-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(8px);
  transition: all 0.3s ease;
}

/* Dark mode support */
:root.theme--dark .loading-backdrop {
  background: rgba(18, 18, 18, 0.85);
}

/* ====================== WRAPPER ====================== */
.loading-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 380px;
  max-width: 90vw;
  padding: 40px 32px 36px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 40px;
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(0, 153, 168, 0.1);
  transition: all 0.3s ease;
}

:root.theme--dark .loading-wrapper {
  background: rgba(30, 30, 35, 0.95);
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.4),
    0 0 0 1px rgba(0, 153, 168, 0.2);
}

/* ====================== SHIELD CONTAINER ====================== */
.shield-container {
  position: relative;
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
}

/* Rotating rings */
.ring-outer {
  position: absolute;
  inset: -8px;
  border-radius: 50%;
  border: 2px solid rgba(0, 153, 168, 0.15);
  border-top-color: #0099a8;
  animation: spin 2s linear infinite;
}

.ring-middle {
  position: absolute;
  inset: -2px;
  border-radius: 50%;
  border: 2px solid rgba(0, 153, 168, 0.1);
  border-right-color: #0099a8;
  animation: spin-reverse 1.5s linear infinite;
}

.ring-inner {
  position: absolute;
  inset: 4px;
  border-radius: 50%;
  border: 1px solid rgba(0, 153, 168, 0.2);
  border-bottom-color: #0099a8;
  animation: spin 1s linear infinite;
}

.shield-icon-wrapper {
  position: absolute;
  inset: 12px;
  background: linear-gradient(135deg, rgba(0, 153, 168, 0.08), rgba(0, 153, 168, 0.02));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.shield-glow {
  position: absolute;
  inset: -20px;
  background: radial-gradient(circle, rgba(0, 153, 168, 0.2), transparent 70%);
  animation: glowPulse 2s ease-in-out infinite;
}

.shield-icon {
  color: #0099a8;
  filter: drop-shadow(0 0 8px rgba(0, 153, 168, 0.5));
  animation: iconPulse 2s ease-in-out infinite;
  z-index: 1;
}

/* Dark mode colors */
:root.theme--dark .ring-outer {
  border-top-color: #00b4c4;
}
:root.theme--dark .ring-middle {
  border-right-color: #00b4c4;
}
:root.theme--dark .ring-inner {
  border-bottom-color: #00b4c4;
}
:root.theme--dark .shield-icon {
  color: #00b4c4;
  filter: drop-shadow(0 0 12px rgba(0, 180, 196, 0.6));
}
:root.theme--dark .shield-glow {
  background: radial-gradient(circle, rgba(0, 180, 196, 0.25), transparent 70%);
}

/* ====================== TITLE ====================== */
.loading-title {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-main {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(135deg, #212121, #0099a8);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  letter-spacing: -0.5px;
}



:root.theme--dark .title-main {
  background: linear-gradient(135deg, #e0e0e0, #00b4c4);
  -webkit-background-clip: text;
  background-clip: text;
}


/* ====================== LOADING TEXT ====================== */
.loading-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
}

.waiting-text {
  font-size: 14px;
  font-weight: 500;
  color: #666;
  letter-spacing: -0.3px;
}

.loading-dots {
  display: flex;
  gap: 4px;
  align-items: center;
}

.dot {
  width: 5px;
  height: 5px;
  background: #0099a8;
  border-radius: 50%;
  animation: dotWave 1.2s ease-in-out infinite;
}

.dot:nth-child(1) { animation-delay: 0s; }
.dot:nth-child(2) { animation-delay: 0.2s; }
.dot:nth-child(3) { animation-delay: 0.4s; }

:root.theme--dark .waiting-text {
  color: #aaa;
}

:root.theme--dark .dot {
  background: #00b4c4;
}



/* ====================== ANIMATIONS ====================== */
@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes spin-reverse {
  to { transform: rotate(-360deg); }
}

@keyframes iconPulse {
  0%, 100% { 
    transform: scale(1);
    opacity: 1;
  }
  50% { 
    transform: scale(1.08);
    opacity: 0.9;
  }
}

@keyframes glowPulse {
  0%, 100% { 
    opacity: 0.3;
    transform: scale(1);
  }
  50% { 
    opacity: 0.7;
    transform: scale(1.2);
  }
}

@keyframes pulse {
  0%, 100% { 
    opacity: 0.3;
    transform: scale(1);
  }
  50% { 
    opacity: 1;
    transform: scale(1.5);
  }
}

@keyframes dotWave {
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.3;
  }
  30% {
    transform: translateY(-6px);
    opacity: 1;
  }
}


/* ====================== RESPONSIVE ====================== */
@media (max-width: 480px) {
  .loading-wrapper {
    width: 320px;
    padding: 32px 24px 28px;
    border-radius: 32px;
  }
  
  .shield-container {
    width: 80px;
    height: 80px;
  }
  
  .title-main {
    font-size: 18px;
  }
  
  .waiting-text {
    font-size: 13px;
  }
  
  .shield-icon {
    font-size: 34px !important;
  }
}

@media (max-width: 360px) {
  .loading-wrapper {
    width: 280px;
    padding: 28px 20px 24px;
  }
  
  .shield-container {
    width: 70px;
    height: 70px;
  }
  
  .title-main {
    font-size: 16px;
  }
}
</style>